import Table, { IColumn, IRow } from '@storeblocks/table';
import { type FC } from 'react';
import styled from 'styled-components';

interface Props {
  columns: IColumn[];
  rows: IRow[];
}

export const FundsTable: FC<Props> = ({ columns, rows }) => {
  return <TableStyled data-test="funds-table" columns={columns} data={rows} />;
};

const TableStyled = styled(Table)`
  & table {
    table-layout: auto;
  }

  /*
    Make the first column take all the remaining space
    to make the other columns only be as wide as its content.
 */
  & th:nth-of-type(1) {
    width: 100%;
  }

  & td {
    vertical-align: top;
  }

  & tr:last-of-type {
    font-weight: bold;

    &:hover {
      color: unset;
    }
  }

  & tr:last-of-type {
    height: 48px;

    td {
      padding: 0 16px;
      vertical-align: middle;
    }
  }
`;
